module.exports = __webpack_public_path__ + "static/media/product_use_case_1.a50ff0e8.svg";